import React from 'react';
import { ProductChangelog } from '../common/components/product-changelog.component';
import pkg from '../../../package.json';

const TouchposeChangelog: React.FC = () => (
  <ProductChangelog
    productName="TouchPose"
    version={(pkg as { touchpose?: { version?: string } }).touchpose?.version ?? '0.0.0'}
    mdPath="/changelog.md"
    publicRepo="squarebit-studios/touchpose-public"
  />
);

export default TouchposeChangelog;
